// libraries
import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { List, Typography } from 'antd';

// locales
import { txt } from '../../../../locales/i18n';
import { formatDate } from '../../../../utils/date';

export function GroupListContentMobile(props: any): JSX.Element {
	const navigateTimeout = useRef<NodeJS.Timeout | null>(null);

	const history = useHistory();
	const location = useLocation();

	useEffect(() => {
		if (navigateTimeout.current !== null) clearTimeout(navigateTimeout.current);

		const itemId = location.hash.replace('#', '');
		const itemSelector = `li#item-${itemId}`;
		const listItemElement = document.querySelector(itemSelector);

		if (listItemElement === null) return;

		navigateTimeout.current = setTimeout(() => {
			listItemElement.scrollIntoView({ behavior: 'auto', block: 'center' });
		}, 100);
	}, [props.dataSource, location.hash]);

	function renderType(type: number): string {
		switch (type) {
			case 1:
				return txt('group.type hidden');

			case 2:
				return txt('group.type password');

			case 3:
				return txt('group.type request');

			case 4:
				return txt('group.type open');

			default:
				return txt('group.type unknown');
		}
	}

	function renderItem(item: Record<string, any>): JSX.Element {
		return (
			<List.Item
				id={'item-' + item.id}
				onClick={() => {
					history.replace({ hash: String(item.id), search: location.search });
					history.push(`/groups/${item.id}`);
				}}
			>
				<StyledListItemContainer>
					<Typography.Text type="secondary">{txt('global.name')}</Typography.Text>
					<Typography.Text ellipsis>{item.name}</Typography.Text>

					<Typography.Text type="secondary">{txt('global.username')}</Typography.Text>
					<Typography.Text ellipsis>{item.username}</Typography.Text>

					<Typography.Text type="secondary">{txt('global.municipality')}</Typography.Text>
					<Typography.Text ellipsis>{item.municipality}</Typography.Text>

					<Typography.Text type="secondary">{txt('global.messages')}</Typography.Text>
					<Typography.Text ellipsis>{item.messages || null}</Typography.Text>

					<Typography.Text type="secondary">{txt('global.members')}</Typography.Text>
					<Typography.Text ellipsis>{item.members || null}</Typography.Text>

					<Typography.Text type="secondary">7 D.</Typography.Text>
					<Typography.Text ellipsis>{item.pastWeekMessages || null}</Typography.Text>

					<Typography.Text type="secondary">Type</Typography.Text>
					<Typography.Text ellipsis>{renderType(item.type)}</Typography.Text>

					<Typography.Text type="secondary">{txt('global.created')}</Typography.Text>
					<Typography.Text ellipsis>{formatDate(item.created)}</Typography.Text>
				</StyledListItemContainer>
			</List.Item>
		);
	}

	return (
		<List
			size="large"
			itemLayout="vertical"
			loading={props.loading}
			renderItem={renderItem}
			dataSource={props.dataSource}
		/>
	);
}

const StyledListItemContainer = styled.div`
	display: grid;
	grid-template-columns: auto 1fr;
	gap: 0ch 1ch;
`;
